import React, { useContext, useState } from 'react'
import { StyledSettingScreen } from './SettingScreen.styled'
import { MyAccountContext } from '../hooks/useMyAccountContext'
import { Product } from '@news-mono/web-common'
import { ScreenType } from '../hooks/useScreen'
import { useProduct } from '../../__product'
import { PerthNowSettingsScreen } from './component/PerthNowSettingsScreen'
import { TheNightlySettingsScreen } from './component/TheNightlySettingsScreen'

export interface SettingsScreenInnerProps {
    activeIndex: number
    onMenuItemClick: (index: number, screen: ScreenType) => void
}

export const SettingScreen = () => {
    const product = useProduct()
    const { setScreenSelected, setScreen, isScreenSelected } =
        useContext(MyAccountContext)
    const [activeIndex, setActiveIndex] = useState<number>(0)

    function onMenuItemClick(index: number, screen: ScreenType) {
        setScreenSelected(true)
        setScreen(screen)
        setActiveIndex(index)
    }

    const props = { activeIndex, onMenuItemClick }
    const isPerthNow = product === Product.PerthNow

    const InnerSettingsScreen = isPerthNow
        ? PerthNowSettingsScreen
        : TheNightlySettingsScreen

    return (
        <StyledSettingScreen show={!isScreenSelected}>
            <InnerSettingsScreen {...props} />
        </StyledSettingScreen>
    )
}
